import store from './store'
import { systemService } from './systemService'

export * from './store/types'

/**
 * Module façade, following AuthorBase's namespaced-bag convention so several modules can be
 * spread into one component's `setup()` return without colliding.
 *
 * `system` holds no per-instance model or list, so it exposes only the shared store and the
 * service. The `model`/`list`/`listArgs` reactives arrive on modules that need them.
 */
export function useSystem () {
  return {
    system: {
      store,
      service: systemService()
    }
  }
}
